module.exports = __webpack_public_path__ + "img/3_178.4ecfc4cc.png";